import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { AvatarModule } from "primeng/avatar";

@Component({
    selector: "kno2-avatar",
    imports: [AvatarModule],
    template: `
        <p-avatar
            [image]="image()"
            [label]="label()"
            shape="circle" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
    public readonly image = input<string>();
    public readonly label = input<string>();
}
